import React from 'react';
import { StyledButtonLink } from './styles';
import { ButtonLinkProps } from './types';
import { ButtonKind, ButtonMode, ButtonSize } from './enums';

const modeToKind: Record<ButtonMode, ButtonKind> = {
  [ButtonMode.Primary]: ButtonKind.Primary,
  [ButtonMode.Secondary]: ButtonKind.Outline,
  [ButtonMode.Tertiary]: ButtonKind.Danger,
  [ButtonMode.Info]: ButtonKind.Soft,
};

const ButtonLink: React.FC<ButtonLinkProps> = ({
  mode = ButtonMode.Primary,
  kind: kindProp,
  size = ButtonSize.Big,
  icon: Icon,
  children,
  ...props
}) => {
  const kind = kindProp ?? modeToKind[mode];
  const buttonTextVariant = size === ButtonSize.Big ? 'body' : 'caption';

  return (
    <StyledButtonLink variant={buttonTextVariant} {...{ kind, size, ...props }}>
      {Icon && <Icon />}
      {children}
    </StyledButtonLink>
  );
};

export default ButtonLink;
